import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { checkPermission } from "../../../../../utils/Authorization/authorization";

import "./GameNavigation.component.scss";

interface GameNavigationProps {
    altMenu?: any;
    children?: any;
}

export interface GameNavigationState {
    showOwnerMenu: boolean;
}

export class GameNavigation extends Component<
    GameNavigationProps,
    GameNavigationState
> {
    constructor(props) {
        super(props);

        this.state = {
            showOwnerMenu: false
        };
    }

    selectOwnerMenu = () => {
        this.setState({
            showOwnerMenu: true
        });
        document.addEventListener("click", this.handleClickOutsideAdminMenu);
    };

    handleClickOutsideAdminMenu = event => {
        if (!document.querySelector(`.owner-link`).contains(event.target)) {
            this.setState({
                showOwnerMenu: false
            });
            document.removeEventListener(
                "click",
                this.handleClickOutsideAdminMenu
            );
        }
    };

    componentWillUnmount() {
        document.removeEventListener("click", this.handleClickOutsideAdminMenu);
    }

    render() {
        return (
            <div className="games-topbar">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            {!this.props.altMenu && (
                                <div className="sub-menu">
                                    {checkPermission("list_games") && (<NavLink
                                        exact
                                        activeClassName="is-active"
                                        to="/games/"
                                    >
                                        Games
                                    </NavLink>)}

                                    {checkPermission("list_bundles") && (<NavLink
                                        exact
                                        activeClassName="is-active"
                                        to="/games/bundles/"
                                    >
                                        Bundles
                                    </NavLink>)}

                                    {/*<NavLink
                                        activeClassName="is-active"
                                        to="/games/import/"
                                    >
                                        Import List
                                    </NavLink>*/}

                                    {checkPermission("manage_game_attributes") && (<NavLink
                                        activeClassName="is-active"
                                        to="/games/attributes/"
                                    >
                                        Game Attributes
                                    </NavLink>)}

                                    {checkPermission("read_game_categories") && (<NavLink
                                        activeClassName="is-active"
                                        to="/games/categories/"
                                    >
                                        Game Categories
                                    </NavLink>)}
                                </div>
                            )}
                            {this.props.altMenu}
                            {this.props.children}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
